import { Flex, Modal, Stack, Text, Title } from '@mantine/core';
import React from 'react';
import FormCreateUpdateReason from '../../components/forms/FormCreateUpdateReason';
import PropTypes from 'prop-types';
import Button from '../../components/elements/Button';

export const RenderModalCreateUpdateReason = ({
  modal,
  setModal,
  handleSubmitReason
}) => {
  const onClose = () => {
    setModal({
      type: modal.type,
      opened: false
    });
  };
  const title = {
    createReason: 'Tambah Alasan Blokir NIK',
    updateReason: 'Perbarui Alasan Blokir NIK',
    createReasonDetail: 'Tambah Keterangan Blokir NIK',
    updateReasonDetail: 'Perbarui Keterangan Blokir NIK'
  };
  return (
    <Modal centered onClose={onClose} opened={modal.opened} radius={12} size="lg"
      title={title[modal.type] || '-'}>
      <FormCreateUpdateReason
        handleSubmitReason={handleSubmitReason}
        initialValues={{ reason: modal?.data?.message || '',
          isRequestUnblock: modal?.data?.isRequestUnblock ,
          isActive: modal?.data?.isActive || false,
          supportDocument: modal?.data?.supportDocument ? [new File([], modal?.data?.supportDocument.split('/')?.[1], {
            type: 'application/pdf',
          })] : [],
          isAttachFile: false
        }}
        onClose={onClose} type={modal.type}/>
    </Modal>
  );
};

RenderModalCreateUpdateReason.propTypes = {
  handleSubmitReason: PropTypes.func,
  modal: PropTypes.object,
  setModal: PropTypes.func,
};

export const RenderModalUpdateStatusConfirmation = ({
  modal,
  setModal,
  handleSubmitSwitchStatus,
  // handleSubmitReason = () => {}
}) => {
  const onClose = () => {
    setModal({
      type: modal.type,
      opened: false
    });
  };
  const title = {
    updateStatusReason: `${modal?.data?.isActive ? 'Nonaktifkan' : 'Aktifkan'} Alasan Blokir NIK`,
    updateStatusReasonDetail: `${modal?.data?.isActive ? 'Nonaktifkan' : 'Aktifkan'} Keterangan Blokir NIK`
  };
  const btnTextSubmit = {
    updateStatusReason: `${modal?.data?.isActive ? 'Nonaktifkan' : 'Aktifkan'} Alasan Blokir`,
    updateStatusReasonDetail: `${modal?.data?.isActive ? 'Nonaktifkan' : 'Aktifkan'} Keterangan Blokir`
  };
  return(
    <Modal centered onClose={onClose} opened={modal.opened} radius={12} size="lg"
      title={<Title fz={30} order={3}>{title[modal.type]}</Title>}>
      <Stack>
        <Text>
            Apakah Anda yakin untuk menonaktifkan alasan blokir NIK <b>“{modal?.data?.message}”</b>?
        </Text>
        <Flex align="center" gap="sm" justify="center">
          <Button fullWidth onClick={onClose} style="outlined" type="button">Batal</Button>
          <Button fullWidth onClick={handleSubmitSwitchStatus}>{btnTextSubmit[modal.type]}</Button>
        </Flex>
      </Stack>
    </Modal>
  );
};

RenderModalUpdateStatusConfirmation.propTypes = {
  handleSubmitReason: PropTypes.func,
  handleSubmitSwitchStatus: PropTypes.func,
  modal: PropTypes.object,
  setModal: PropTypes.func,
};
